// extracted by mini-css-extract-plugin
module.exports = {"option":"menuForItem_option__3udmD","disabled":"menuForItem_disabled__o_cPk"};